// =============================================================================
// Child theme entry — project-specific JS goes here.
// The parent theme (epos-academy) handles core behaviors; use this file only for
// Epos Academy overrides or new features that don't belong in core.
// =============================================================================

// Example:
// import "./modules/academy-hero.js";
import "./modules/article-where.js";
import "./modules/figure-lightbox.js";
import "./modules/guide-hydrate.js";
import "./modules/home-topics.js";
import "./modules/home-search.js";

console.log("[epos-academy-child] loaded");
